@if (loading) {
  <patron-spinner size="lg" [centered]="true"></patron-spinner>
}

<div class="col-12">
  <div class="card">
    <div class="card-body">
      @if (!loading && !tickets.length) {
        <div class="row mx-0">
          <div class="col text-muted text-center mt-2">
            <b><i>Nenhum chamado visto recentemente</i></b>
          </div>
        </div>
      }

      @if (!loading && tickets.length) {
        <div>
          <div class="row">
            @for (ticket of tickets; track ticket; let i = $index) {
              <div class="col-xl-4 col-lg-6">
                <app-ticket-card-container
                  [ticketTask]="{ ticket: ticket }"
                  [showDate]="false"
                  (click)="openTicket(ticket)"></app-ticket-card-container>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
